// import {} from '../css/glide.scss'
import Glide from '@glidejs/glide';

class Glider {
    glides = null

    constructor(glides) {
        this.glides = glides;
    }

    initialize() {
        for (var i = 0; i < this.glides.length; i++) {
            let glide = this.glides.item(i);
            new Glide(glide, JSON.parse(glide.dataset.glide)).mount();
        }
    }
}

export default Glider;
